import React, { useRef } from 'react';
import { Platform } from 'react-native';
import { Button, ListItem, Text } from '@rneui/themed';
import BottomSheet, { BottomSheetView } from '@gorhom/bottom-sheet';
import { Portal } from '@gorhom/portal';
import { useSafeAreaInsets } from 'react-native-safe-area-context';
import { useTheme } from '../../../hooks';
import { BottomSheetBackdrop, useJump, } from '../../..';
import { PlaybackSpeed } from './PlaybackSpeed';
import { usePlaybackSpeed } from '../../..';
export const UnmemoizedTrackSettings = ({ size, buttonStyle, iconStyle, playbackSpeedOptions = {}, children = null, }) => {
    const { top, bottom } = useSafeAreaInsets();
    const { jumpForward, jumpBackward, nextJumpForward, nextJumpBackward, } = useJump();
    const { colors } = useTheme();
    const bottomSheetRef = useRef(null);
    const { playbackSpeed } = usePlaybackSpeed();
    return (React.createElement(React.Fragment, null,
        React.createElement(Button, { type: "clear", onPress: () => bottomSheetRef.current?.expand(), style: buttonStyle },
            React.createElement(Text, { style: iconStyle }, playbackSpeed.toFixed(1)),
            React.createElement(Text, null, "x")),
        React.createElement(Portal, { hostName: "modal" },
            React.createElement(BottomSheet, { ref: bottomSheetRef, backdropComponent: BottomSheetBackdrop, index: -1, topInset: top, activeOffsetY: Platform.OS === 'android' ? [-5, 5] : undefined, failOffsetX: Platform.OS === 'android' ? [-5, 5] : undefined, enablePanDownToClose: true, backgroundStyle: { backgroundColor: colors.backgroundPrimary }, handleIndicatorStyle: { backgroundColor: colors.textPrimary }, containerStyle: { zIndex: 3000 } },
                React.createElement(BottomSheetView, { style: {
                        backgroundColor: colors.backgroundPrimary,
                        paddingBottom: bottom,
                    } },
                    React.createElement(ListItem, null,
                        React.createElement(ListItem.Content, null,
                            React.createElement(PlaybackSpeed, { ...playbackSpeedOptions }))),
                    React.createElement(ListItem, null,
                        React.createElement(ListItem.Content, null,
                            React.createElement(ListItem.Title, null,
                                React.createElement(Text, { bold: false }, "Jump Backward"))),
                        React.createElement(Button, { title: `${jumpBackward}s`, onPress: () => nextJumpBackward() })),
                    React.createElement(ListItem, null,
                        React.createElement(ListItem.Content, null,
                            React.createElement(ListItem.Title, null,
                                React.createElement(Text, { bold: false }, "Jump Forward"))),
                        React.createElement(Button, { title: `${jumpForward}s`, onPress: () => nextJumpForward() })),
                    children)))));
};
export const TrackSettings = React.memo(UnmemoizedTrackSettings, (prev, next) => {
    return prev.size === next.size;
});
//# sourceMappingURL=TrackSettings.js.map